module.exports = __webpack_public_path__ + "static/img/info-img-2.90fce0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/info-img-2.png
// module id = 3BvZ
// module chunks = 0